<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div
        class="pull-left pulse-cell"
        style="height: 18px;"
        v-bind="attrs"
        v-on="on"
      >
        <div class="pull-left pulse-arrow" v-if="item[headerKey] > 0">
          <v-icon aria-hidden="true">mdi-arrow-up</v-icon>
        </div>
        <div class="pull-left pulse-arrow" v-if="item[headerKey] < 0">
          <v-icon aria-hidden="true">mdi-arrow-down</v-icon>
        </div>
        <div
          class="pull-left pulse-arrow"
          v-if="item[headerKey] === 0"
          style="opacity: 0;"
        >
          -
        </div>
        <div class="pull-left pulse-delta">
          {{ Math.floor(item[headerKey]) }}
        </div>
        <div class="clearfix"></div>
      </div>
    </template>
    <span>{{ item.pulseLocationName }}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: "AssetPulseDelta",
  props: {
    item: {
      type: Object,
      required: true,
    },
    headerKey: {
      type: String,
      required: true,
    },
  },
};
</script>
<style>
.pulse-cell .pulse-arrow i {
  font-size: 125%;
  margin-bottom: 4%;
}
.pulse-cell .pulse-delta {
  font-size: smaller;
  font-weight: lighter;
  opacity: 0.75;
  margin-top: 4%;
}
</style>
